import { ROLES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(ROLES_ENDPOINT);
export default instance;
